import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import baseTheme, { CONTRAST_NORMAL, SCHEME_DARK } from './theme';
var baseColors = baseTheme.colors;
export default _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: _objectSpread(_objectSpread({}, baseTheme.colors), {}, {
    SCHEME: SCHEME_DARK,
    CONTRAST: CONTRAST_NORMAL,
    bg: baseColors.bgDark,
    bgPlaceholder: baseColors.bgPlaceholderDark,
    ctrl: baseColors.ctrlDark,
    ctrlBg: baseColors.ctrlBgDark,
    ctrlDisabled: baseColors.ctrlDisabledDark,
    ctrlDisabledLabel: baseColors.ctrlDisabledLabelDark,
    ctrlHover: baseColors.ctrlHoverDark,
    footerBg: baseColors.footerBgDark,
    keyline: baseColors.keylineDark,
    label: baseColors.labelDark,
    labelCaption: baseColors.labelCaptionDark,
    labelPlaceholder: baseColors.labelPlaceholderDark,
    labelLegal: baseColors.labelLegalDark,
    navBg: baseColors.navBgDark,
    navLabel: baseColors.navLabelDark,
    navLabelDisabled: baseColors.navLabelDisabledDark,
    navLabelHover: baseColors.navLabelHoverDark,
    navLabelSelected: baseColors.navLabelSelectedDark,
    title: baseColors.titleDark,
    badInputBdr: baseColors.badInputBdrDark,
    badInputBg: baseColors.badInputBgDark,
    badInputLabel: baseColors.badInputLabelDark,
    error: baseColors.errorDark,
    errorHover: baseColors.errorHoverDark,
    errorBdr: baseColors.errorBdrDark,
    errorBg: baseColors.errorBgDark,
    info: baseColors.infoDark,
    infoHover: baseColors.infoHoverDark,
    infoBdr: baseColors.infoBdrDark,
    infoBg: baseColors.infoBgDark,
    success: baseColors.successDark,
    successHover: baseColors.successHoverDark,
    successBdr: baseColors.successBdrDark,
    successBg: baseColors.successBgDark,
    warning: baseColors.warningDark,
    warningHover: baseColors.warningHoverDark,
    warningBdr: baseColors.warningBdrDark,
    warningBg: baseColors.warningBgDark,
    clrBlue: baseColors.clrBlueDark,
    clrGreen: baseColors.clrGreenDark,
    clrOrange: baseColors.clrOrangeDark,
    clrPurple: baseColors.clrPurpleDark,
    clrTeal: baseColors.clrTealDark,
    clrGray: baseColors.clrGrayDark,
    clrIndigo: baseColors.clrIndigoDark,
    clrPink: baseColors.clrPinkDark,
    clrRed: baseColors.clrRedDark,
    clrYellow: baseColors.clrYellowDark,
    appleMusicRed: baseColors.appleMusicRedDark
  })
});